import router from "@/router";
import { http } from "@/config/http";
import _ from "lodash";

const namespaced = true;

const getDefaultState = () => {
  return {
    roleData: {
      role_id: '',
      role_name: '',
      system_role_id:'',
      permissions: [], 
      role_status : 1
    }, 
    errors:[],
    sysRoles: {},
    permissions_list : {}
  };
};

const state = getDefaultState();

const getters = {
};

const mutations = {
  setRoleData(state, data) { 
    state.roleData.role_id = data.role.id;
    state.roleData.role_name = data.role.name;
    state.roleData.role_status = data.role.status;
    state.roleData.permissions = data.permissions;
    state.roleData.system_role_id = data.role.sys_role_id;
  },

  resetRoleData(state,data) { 
    state.errors = [];
    state.roleData.role_id = '';
    state.roleData.role_name = '';
    state.roleData.role_status = 1;
    state.roleData.permissions = [];
    state.roleData.system_role_id = '';
    
  },

  setSystemRoles(state, data) { 
    state.sysRoles = data;
  },
  setFormErrors(state,data){   
    state.errors = [];
    if(data){
      state.errors = data.details;
    }
  },

  setRoleList(state, data) { 
    state.permissions_list = data; 
  },


};

const actions = {
  resetRoleData({ commit }, data) {
    commit('resetRoleData');    
  },
  async getRoleData({ commit }, data) {
    let role_id = data;

    await http
      .get("roles/" + role_id, null)
      .then(response => {
        commit('setRoleData', response.data);
      })
      .catch(error => { 
        commit('showAlert', {
          title: "Error!",
          msg: "Error occured while retrieving role data.",
          type: "error",
          position: "rightTop"
        }, { root: true });
      });
  },

  async updateRoleData({ commit }, data) {
    return new Promise((resolve, reject) => {
     http
      .post("roles", {
        role_id: state.roleData.role_id,
        name: state.roleData.role_name,
        status: state.roleData.role_status,
        permissions: state.roleData.permissions,
        system_role_id : state.roleData.system_role_id
      })
      .then(response => { 
        if (response.data.success) { 
            commit('setFormErrors', '');
            resolve(response);         
        } else if (response.data.error) {
          if(response.data.error.code == "Exception"){
            resolve(response);
          }else{
            commit('setFormErrors', response.data.error);
            resolve(response); 
          }
        }
      })
      .catch(error => { 
        commit('showAlert', {
          title: "Error!",
          msg: "Error occured while updating role data.",
          type: "error",
          position: "centerTop"
        }, { root: true });
      });
    });
  },

  async insertRoleData({ commit }, data) {
    return new Promise((resolve, reject) => {
       http
      .post("roles/create", { 
        name: state.roleData.role_name,
        status: state.roleData.role_status,
        permissions: state.roleData.permissions,
        system_role_id : state.roleData.system_role_id
      })
      .then(response => { 
        if (response.data.success) { 
            commit('setFormErrors', []);
            resolve(response);         
        } else if (response.data.error) {
          if(response.data.error.code == "Exception"){
            resolve(response);
          }else{
            commit('setFormErrors', response.data.error);
            resolve(response); 
          }
        }
      })
      .catch(error => { 
        commit('showAlert', {
          title: "Error!",
          msg: "Error occured while inserting role data.",
          type: "error",
          position: "centerTop"
        }, { root: true });
      });
    });
    
  },
  async getSystemRoles({ commit }, data) {
      await http
      .get("roles/sys_roles", null)
      .then(response => {
        commit('setSystemRoles', response.data.data);
      })
      .catch(error => { 
        commit('showAlert', {
          title: "Error!",
          msg: "Error occured while retriving data.",
          type: "error",
          position: "rightTop"
        }, { root: true });
      });
  },
  async getRoleList({ commit }, data) {  
    await http
      .get("roles/list", null)
      .then(response => {   
        commit('setRoleList', response.data.permissions);
      })
      .catch(error => { 
        commit('showAlert', {
          title: "Error!",
          msg: "Error occured while retriving role data.",
          type: "error",
          position: "rightTop"
        }, { root: true });
      });
  },

  
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
